import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-29360c65")
const _hoisted_1 = ["href"]
const _hoisted_2 = ["src", "alt"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: "social-link",
    href: _ctx.to
  }, [
    _createElementVNode("img", {
      src: _ctx.iconPath,
      alt: _ctx.name
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}